import { render, staticRenderFns } from "./AccessibilityWidget.vue?vue&type=template&id=f6488d20&scoped=true"
import script from "./AccessibilityWidget.vue?vue&type=script&lang=js"
export * from "./AccessibilityWidget.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityWidget.vue?vue&type=style&index=0&id=f6488d20&prod&lang=css"
import style1 from "./AccessibilityWidget.vue?vue&type=style&index=1&id=f6488d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6488d20",
  null
  
)

export default component.exports